import * as copy from 'config/onboardingV4/copy';
import { needsNoHelp, type Knowledge } from 'utils/triageKnowledge';
import { phrase, type Person } from 'utils/person';

/** One line per way we can help, from what is known so far. */
export const helpLines = (person: Person, knowledge: Knowledge): string[] => [
  phrase(copy.HELP.money, person),
  ...(needsNoHelp(knowledge) ? [] : [phrase(copy.HELP.care, person)]),
  copy.HELP.expert,
];
